import React, { FC } from 'react'
import { BlogAd } from './style'

//* Components
import Button from '../button'
import Typography from '../typography'
import WrapperImage from '../wrapperImage'

type Props = {
  ctaUrl: string
  ctaText: string
  adText: string
  adImage: string
  adImageAlt: string
  className?: string
}

const BlogAds: FC<Props> = ({ ctaUrl, ctaText, adText, adImage, adImageAlt, className }) => {
  return (
    <BlogAd data-cy="BlogAds" className={className || undefined}>
      <div className="BlogAd__Img-Container">
        <WrapperImage
          className="BlogAd__Img"
          src={adImage}
          alt={adImageAlt}
          width={540}
          height={544}
          threshold={650}
        />
      </div>

      <Typography className="BlogAd__Text" type="header5">
        {adText}
      </Typography>

      <Button icon={true} href={ctaUrl} text={ctaText} type="primary" size="small" theme="dark" />
    </BlogAd>
  )
}

export default BlogAds
